import PropTypes from 'prop-types'
import i18n from 'i18next'
import React from 'react'
import {useCurrentUserId} from '#hooks/store/useCurrentUserId'
import {TriggerWithTooltip} from '#components/m/MeineAzubis/TriggerWithTooltip'

export default function FeedbackUserDisplayField({user}) {
  const {currentUserId} = useCurrentUserId()
  let userName
  if (!user) {
    userName = ''
  } else if (user.hasErrors) {
    userName = i18n.t('unknown_user')
  } else {
    const isSelf = user.id === currentUserId
    userName = isSelf ? i18n.t('user_myself') : `${user.firstname} ${user.lastname}`
  }

  return (
    <TriggerWithTooltip text={userName} modifiers={['dark', 'nopadding']}>
      <span>{userName}</span>
    </TriggerWithTooltip>
  )
}

FeedbackUserDisplayField.propTypes = {
  user: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    id: PropTypes.number,
    hasErrors: PropTypes.bool,
  }),
}
